import config from "../config"
import contractOptions from "./contractOptions";

const fetchData = async (id: number, contract: contractOptions): Promise<any> => {
    let url = ""
    if (contract === 'bears') {
        url = config.bearsCID;
        url += "/" + id;
    } else if (contract === 'hives') {
        url = config.hivesCID;
        url += "/" + id;
    } else if (contract === 'vx') {
        url = config.VXCID;
        url += "/" + id;
    } else if (contract === 'bees') {
        url = config.beesCID;
        url += id;
    };

    return fetch(url);

}

export const fetchBee = async (id: number): Promise<any> => {
    const response = await fetch(`${config.beesCID}${id}`);
    return {
        data: await response.json()
    };
}

export const fetchBear = async (id: number): Promise<any> => {
    const response = await fetch(`${config.bearsCID}/${id}`);
    return {
        data: await response.json()
    };
}

export const fetchHive = async (id: number): Promise<any> => {
    const response = await fetch(`${config.hivesCID}/${id}`);
    return {
        data: await response.json()
    };
}

export default fetchData;